import * as actions from 'constants/ActionTypes';
import { generateReducers } from 'utils/reducers';

export default generateReducers({
  [actions.SET_ORGDOMAIN] : (state, action) => action.payload
}, null);